module.exports = __webpack_public_path__ + "static/fochlucan_bandore-8deee235eafc851dcd33effd1b31e33f.jpg";